import { trpc } from '@/shared/api/trpc';

// Suppliers for one item enriched with CRM details (phone / address / email /
// website) — used by the edit-modal Supplier tab. Lazily enabled so the join
// only runs when the tab is opened.
export const useOperationItemSuppliers = (
  itineraryItemId: string | null,
  options?: { enabled?: boolean }
) =>
  trpc.operations.itemSuppliers.useQuery(
    { itineraryItemId: itineraryItemId ?? '' },
    { enabled: (options?.enabled ?? true) && Boolean(itineraryItemId) }
  );
